// Plain text → text and link segments, for messages from the team (Phase 3:
// plain text + links, owner 2026-10-04). Nothing is parsed as HTML: the caller
// renders the segments as React text and <a> elements, so markup in a message
// shows as the characters it is.
//
// ⚠️ Only http(s) becomes a link — never javascript:, data: or anything else.

export type TextSegment = { type: 'text'; text: string } | { type: 'link'; text: string; href: string };

const URL_RE = /\bhttps?:\/\/[^\s<>"']+/gi;
// punctuation that ends a sentence, not the address ("see https://x.com.")
const TRAILING = /[.,;:!?)\]}'"]+$/;

export function linkifyText(text: string): TextSegment[] {
  const segments: TextSegment[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_RE)) {
    const start = match.index ?? 0;
    let raw = match[0];
    const trail = TRAILING.exec(raw)?.[0] ?? '';
    // keep a closing ")" that belongs to the address, e.g. a wiki link with "(x)"
    const keepParen = trail.startsWith(')') && raw.slice(0, -trail.length).includes('(');
    const cut = keepParen ? trail.slice(1) : trail;
    raw = cut ? raw.slice(0, -cut.length) : raw;

    let href: string;
    try {
      const url = new URL(raw);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') continue;
      href = url.href;
    } catch {
      continue;
    }

    if (start > last) segments.push({ type: 'text', text: text.slice(last, start) });
    segments.push({ type: 'link', text: raw, href });
    last = start + raw.length;
  }
  if (last < text.length) segments.push({ type: 'text', text: text.slice(last) });
  return segments;
}
